import { MyEntities } from "components/icons/LeftNav/MyEntities";
import React from "react";

export const EntityBoxHeader = () => (
  <div className="t-flex t-gap-3 t-items-center">
    <div className="t-size-8 t-flex t-items-center t-justify-center t-rounded-full t-bg-surface-lighter-grey">
      <MyEntities />
    </div>
    <div className="t-text-subtitle t-t-text-text-100">New entity</div>
  </div>
);
